module.exports = __webpack_public_path__ + "static/media/Test10.dac08f66.bmp";